import { createRootRoute, createRoute, createRouter, redirect } from '@tanstack/react-router';
import { Catalog, Home, ProductDetail } from '@/containers';

// Create root route
const rootRoute = createRootRoute();

// Create index route
const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: Home,
});

// Route to handle /index.html redirect
const indexHtmlRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/index.html',
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});

// Create catalog route
const catalogRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/catalog',
  component: Catalog,
  validateSearch: (search: Record<string, unknown>) => {
    const page = search.page ? Number(search.page) : 1;
    return {
      category: (search.category as 'all' | 'new' | 'used' | 'buffalo' | 'power-citros' | 'parts') || 'all',
      page: page > 0 ? page : 1,
    };
  },
});

// Create product detail route
const productDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/product/$type/$id',
  component: ProductDetail,
  validateSearch: () => ({}),
});

// Catch-all route for 404 - redirects to home
const notFoundRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '*',
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});

// Create route tree
const routeTree = rootRoute.addChildren([
  indexRoute,
  indexHtmlRoute,
  catalogRoute,
  productDetailRoute,
  notFoundRoute,
]);

// Create router instance
export const router = createRouter({ routeTree });
